const variants = {
  small: {
    width: "fit-content",
    height: "25px",
    fontSize: "body-small",
    display: "flex",
    "justify-content": "center",
    "align-items": "center",
  },
  large: {
    width: "92px",
    height: "29px",
    fontSize: "h6",
    display: "flex",
    "justify-content": "center",
    "align-items": "center",
  },
};

export default variants;
